// export const baseURL = "http://192.168.1.16:8088/api/";
// export const baseImageURL = "http://192.168.1.16:8088";
// old one - export const redirectURL = "http://192.168.1.16:3001/";
export const baseURL = "https://merchantapi.blockbolt.io/api/";
export const baseImageURL = "https://merchantapi.blockbolt.io";
export const redirectURL = "https://checkout.blockbolt.io/";
